/**
 * Created by staffanrantzow on 08/11/16.
 */

import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { Utils } from 'frilans-finans';

export const ROT_RUT = 'rr';
export const EXPRESS = 'express';
export const EXPRESS_NOT_ROT_RUT = 'express_not_rot_rut';
export const VAT = 'vat';

class ReadMoreModal extends React.Component {

  static propTypes = {
    text: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      open: true
    };
  };

  createMarkup (html) {
    return {__html: html};
  }

  renderContent () {
    switch (this.props.text) {
      case ROT_RUT:
        return (
          <div>
            <h2><Translate content='ROT_RUT'/></h2>
            <p dangerouslySetInnerHTML={this.createMarkup(Utils.getLineBreaks(proxyCounterpart('RUT_ROT_INFO')))}>
            </p>
          </div>
        );
      case EXPRESS:
        return (
          <div>
            <h2><Translate content='EXPRESS_PAYMENT'/></h2>
            <p dangerouslySetInnerHTML={this.createMarkup(
              Utils.getLineBreaks(proxyCounterpart('EXPRESS_PAYMENT_INFO'))
            )}>
            </p>
          </div>
        );
      case EXPRESS_NOT_ROT_RUT:
        return (
          <div>
            <h2><Translate content='ALERT'/></h2>
            <p dangerouslySetInnerHTML={this.createMarkup(
              Utils.getLineBreaks(proxyCounterpart('EXPRESS_PAYMENT_NOT_ROT_RUT'))
            )}>
            </p>
          </div>
        );
      case VAT:
        return (
          <div>
            <h2><Translate content='VAT'/></h2>
            <p dangerouslySetInnerHTML={this.createMarkup(
              Utils.getLineBreaks(proxyCounterpart('VAT_INFO'))
            )}>
            </p>
          </div>
        );
    }
  }

  render () {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen={this.state.open}
        onRequestClose={this.props.close}>
        <div className='modal-content read-more-modal'>
          <button className='close' onClick={this.props.close}></button>
          {this.renderContent()}
        </div>
      </Modal>
    );
  }

}

export default ReadMoreModal;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/read-more-modal/read-more-modal.js
 **/